import { ENVPRE } from 'app-config/index.js'
export const accountId = props => {
    const { pathname } = window.location
    const account = localStorage.getItem(`${ENVPRE}account`)
    const accounts = localStorage.getItem(`${ENVPRE}accounts`)
    const propsId = props?.params?.id

    if (accounts?.includes('*') || pathname.includes('*')) {
        const arr = pathname.split('/')
        if (arr[1]) return arr[1]
    }

    if (account) {
        if (!accounts) {
            return propsId === account ? accounts : accounts
        } else {
            if (propsId) {
                if (accounts.includes(propsId)) {
                    localStorage.setItem(`${ENVPRE}account`, propsId)
                    return propsId
                }
            }
            return account
        }
    }
    return null
}

export const isTrialAccount = $acc => {
    if (!$acc) return false
    if (!$acc?.farms?.data?.items[0]) return false
    const account = localStorage.getItem(`${ENVPRE}account`)
    return account ? JSON.parse(localStorage.getItem(`${account}.account`))?.accountStatus === 'trialing' : false
}

export function getAccountId(tenant) {
    const localId = accountId()
    const tenantId = tenant
    const winlocId = window.location.pathname.includes('/') && !window.location.pathname.includes('*') ? window.location.pathname.split('/')[0] : null
    return tenantId || (localId && !localId.includes('*')) ? localId : winlocId
}
